module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-9063af6e.png";